<script setup lang="ts">
const props = defineProps<{
  endDate: string | null;
}>();

const remaining = ref<number | null>(null);

function calcRemaining() {
  if (!props.endDate) return null;
  const diff = new Date(props.endDate).getTime() - Date.now();
  return diff > 0 ? diff : 0;
}

function formatCountdown(ms: number) {
  const totalSeconds = Math.floor(ms / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const hh = String(hours).padStart(2, "0");
  const mm = String(minutes).padStart(2, "0");
  const ss = String(seconds).padStart(2, "0");

  return days > 0 ? `${days}d ${hh}:${mm}:${ss}` : `${hh}:${mm}:${ss}`;
}

const { pause } = useIntervalFn(
  () => {
    const r = calcRemaining();
    remaining.value = r;
    if (r === 0) pause();
  },
  1000,
  { immediateCallback: true },
);

onMounted(() => {
  remaining.value = calcRemaining();
});

const countdownText = computed(() => {
  if (remaining.value === null || remaining.value === 0) return "";
  return formatCountdown(remaining.value);
});

const label = computed(() => (countdownText.value ? true : null));
</script>

<template>
  <p v-if="label" class="promo-countdown">
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </svg>
    <span
      >Promocja kończy się za: <strong>{{ countdownText }}</strong></span
    >
  </p>
</template>

<style scoped>
.promo-countdown {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 10px 16px;
  background: var(--promo-pill-bg);
  border: var(--promo-pill-border);
  border-radius: 55px;
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--color-black, #151515);
  line-height: 1;
}

[data-brand="youlook"] .promo-countdown {
  background: transparent;
  padding-left: 0;
}

.promo-countdown strong {
  font-weight: 700;
  color: var(--color-sale, #f83e3e);
}
</style>
